
import Siacoin from "../../../assets/filled/Siacoin.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function SiacoinIcon({ className, dataTestid = "SiacoinIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Siacoin data-testid={dataTestid} className={classes} {...rest} />
  );
}
